import { useWeb } from "../../context/Dashboard/contextWeb.js";
import { useDesign } from "../../context/contextDesign.js";
import Vid5 from "../../assets/vid/network/vid-5.webm";
import "../style/scan-card.css";

const ScanCard = () => {
  const {
    urlScanLoading,
    urlDashboardView,
    handleSubmit,
    setUrl,
    url,
    error,
    authorizationConfirmed,
    activeScanAuthorized,
    setAuthorizationConfirmed,
    setActiveScanAuthorized
  } = useWeb();
  const { toggleUpgradeCard } = useDesign();

  return (
    <div className="scan-card d-flex justify-content-center align-items-center">
      <div className="card shadow-sm border-1 rounded-4">
        <div className="d-flex flex-row align-items-center h-100 rounded-4">

          {/* 🔹 Left: Form Section */}
          <div className="scan-form-section p-3 w-50">
            <form
              onSubmit={handleSubmit}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              {/* Title */}
              <div className="fs-1 fw-bold text-center heading mb-3">
                Scan Your URL
              </div>

              {/* Description */}
              <div
                className="fs-6 text-center fw-semibold mb-4 subheading"
                style={{ width: 280 }}
              >
                Enter the URL below to scan for potential vulnerabilities.
              </div>

              {/* Input Field */}
              <div
                className="mb-2 w-100 input-group rounded-2"
                style={{ height: 43 }}
              >
                <input
                  type="text"
                  placeholder="Enter URL"
                  className="p-2 text-center form-control"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  disabled={urlScanLoading || urlDashboardView}
                />
              </div>
              <div className="mb-3 fw-semibold">ex: https://www.example.com</div>

              <div className="w-100 mb-3" style={{ maxWidth: 390 }}>
                <label className="d-flex align-items-start gap-2 small mb-2">
                  <input
                    className="form-check-input mt-1"
                    type="checkbox"
                    checked={authorizationConfirmed}
                    onChange={(event) => setAuthorizationConfirmed(event.target.checked)}
                    disabled={urlScanLoading || urlDashboardView}
                  />
                  <span>
                    I confirm that I own this target or have written permission to scan it.
                  </span>
                </label>
                <label className="d-flex align-items-start gap-2 small text-muted">
                  <input
                    className="form-check-input mt-1"
                    type="checkbox"
                    checked={activeScanAuthorized}
                    onChange={(event) => setActiveScanAuthorized(event.target.checked)}
                    disabled={
                      !authorizationConfirmed || urlScanLoading || urlDashboardView
                    }
                  />
                  <span>Run the bounded active security tests for fuller coverage.</span>
                </label>
              </div>

              <div style={{ width: 260 }}>
                {error && (
                  <div
                    className="error-hover text-danger text-center fw-semibold mb-2"
                    onClick={error.card ? toggleUpgradeCard : undefined}
                    style={{ cursor: error.card ? "pointer" : "default" }}
                  >
                    {error.message}
                  </div>
                )}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="btn btn-success w-100 py-2 fw-semibold fs-6"
                disabled={
                  urlScanLoading ||
                  urlDashboardView ||
                  !url ||
                  !authorizationConfirmed
                }
                style={{ height: 46 }}
              >
                Submit
              </button>
            </form>
          </div>

          {/* 🔹 Right: Video Section */}
          <div className="scan-video-section h-100 w-50">
            <video
              className="img-fluid h-100"
              style={{ objectFit: "cover", borderRadius: "0 1rem 1rem 0" }}
              src={Vid5}
              autoPlay
              loop
              muted
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanCard;
